import { createTypes } from '../../utils/helpers';

const HIERARCHY: any = createTypes('HIERARCHY');
const HIERARCHY_CHECKED: any = createTypes('HIERARCHY_CHECKED');
const HIERARCHY_CLEAR = 'HIERARCHY_CLEAR';
export { HIERARCHY, HIERARCHY_CHECKED, HIERARCHY_CLEAR };
